module.exports = __webpack_public_path__ + "img/landing-page-3.508296bf.webp";